import { allPOItemAssoc, poItemColorAssoc, poItemStyleAssoc } from "data/pimData";
import { channelTypes, wearHouses } from "components/PimDashboard/DashboardComponents/Buying/BuyingSheet/data";
import { testData } from "./RenderTabs/CreatePoTab/testData";

const PO_STORE_KEY = "relook:fob-po-store:v1";
const SUPPLIER_STORE_KEY = "relook:fob-supplier-store:v1";
const SIZE_MASTER_STORE_KEY = "relook:fob-size-master-store:v1";

const clone = (value) => JSON.parse(JSON.stringify(value));

const isBrowser = () => typeof window !== "undefined" && !!window.localStorage;

const readJson = (key, fallback) => {
	if (!isBrowser()) return clone(fallback);
	try {
		const raw = window.localStorage.getItem(key);
		return raw ? JSON.parse(raw) : clone(fallback);
	} catch (error) {
		return clone(fallback);
	}
};

const writeJson = (key, value) => {
	if (!isBrowser()) return;
	window.localStorage.setItem(key, JSON.stringify(value));
};

const createSizeTypeMaster = () => [
	{
		size_type: "S-M",
		s1: "S",
		s2: "M",
		s3: null,
		s4: null,
		s5: null,
		s6: null,
		s7: null,
		s8: null,
		s9: null,
		s10: null,
		s11: null,
		s12: null,
		s13: null,
		s14: null,
		s15: null,
		s16: null,
		s17: null,
		s18: null,
		s19: null,
		s20: null,
		s21: null,
		s22: null,
		s23: null,
		s24: null,
		s25: null,
		s26: null,
		s27: null,
		s28: null,
		s29: null,
		s30: null,
	},
	{
		size_type: "L-XL",
		s1: "L",
		s2: "XL",
		s3: null,
		s4: null,
		s5: null,
		s6: null,
		s7: null,
		s8: null,
		s9: null,
		s10: null,
		s11: null,
		s12: null,
		s13: null,
		s14: null,
		s15: null,
		s16: null,
		s17: null,
		s18: null,
		s19: null,
		s20: null,
		s21: null,
		s22: null,
		s23: null,
		s24: null,
		s25: null,
		s26: null,
		s27: null,
		s28: null,
		s29: null,
		s30: null,
	},
];

const createSuppliers = () => [
	{
		company_name: "RARE SUPPLIES LTD",
		communication_office_pin_code: 122506,
		supplierFactories: [
			{ name: "Main", factory_pin_code: 122506 },
			{ name: "North Unit", factory_pin_code: 110001 },
		],
	},
	{
		company_name: "FASHION SOURCING CO",
		communication_office_pin_code: 562106,
		supplierFactories: [{ name: "Main", factory_pin_code: 562106 }],
	},
];

const normalizeStyle = (style) => {
	const firstColorEntry = style?.styleColorBuying?.[0];
	const firstQtyEntry = firstColorEntry?.colorBuyingQty?.[0];
	const totalQty = style?.styleColorBuying?.reduce((styleAcc, colorRow) => {
		return (
			styleAcc +
			(colorRow?.colorBuyingQty?.reduce((qtyAcc, qtyRow) => {
				return qtyAcc + (Number(qtyRow?.total_qty) || 0);
			}, 0) || 0)
		);
	}, 0);

	return {
		...style,
		id: style.id,
		buy_qty: totalQty,
		bought_qty: 0,
		channel: firstQtyEntry?.channel || "EBO",
		warehouse: firstQtyEntry?.warehouse || wearHouses.GGN.key,
		stage: style?.stage || "SOURCING",
		image: style?.styleImages?.[0]?.url || "",
		main_image: style?.styleImages?.[0]?.url || "",
		color: firstColorEntry?.buyingColor?.color || "Color",
		pallete: firstColorEntry?.buyingColor?.pallete || "Palette",
	};
};

const getStyleCatalog = () => {
	return testData.map((style, index) => ({
		...normalizeStyle(style),
		id: style.id || `style-${index + 1}`,
	}));
};

const getStyleColorRecord = (style, colorId) => {
	const colorEntry = style?.styleColorBuying?.find((row) => `${row?.color_id}` === `${colorId}`) || style?.styleColorBuying?.[0];
	const firstQty = colorEntry?.colorBuyingQty?.[0];
	return {
		color: colorEntry?.buyingColor?.color || `Color ${colorId ?? ""}`.trim(),
		pallete: colorEntry?.buyingColor?.pallete || `Palette ${colorId ?? ""}`.trim(),
		channel: firstQty?.channel || channelTypes.EBO.key,
		warehouse: firstQty?.warehouse || wearHouses.GGN.key,
	};
};

const getItemRowsFromBody = (body) => {
	const styles = getStyleCatalog();
	return (body?.fobPoItems || []).map((item, index) => {
		const style = styles.find((row) => `${row.id}` === `${item.style_id}`) || styles[0];
		const color = getStyleColorRecord(style, item.color_id);
		return {
			...clone(item),
			id: item.id || `${Date.now()}-${index}`,
			[poItemStyleAssoc]: style,
			[poItemColorAssoc]: color,
		};
	});
};

const seedPoRows = () => {
	const styles = getStyleCatalog();
	const firstStyle = styles[0];
	const firstColor = firstStyle?.styleColorBuying?.[0];
	const firstQty = firstColor?.colorBuyingQty?.[0];
	if (!firstStyle || !firstQty) return [];
	return [
		{
			id: "po-1",
			order_no: "FOB-1001",
			date: new Date().toISOString(),
			owner_site: firstQty?.warehouse || wearHouses.GGN.key,
			channel: firstQty?.channel || channelTypes.EBO.key,
			vendor_name: "RARE SUPPLIES LTD",
			factory: "Main",
			currency: "INR",
			purchase_type: "FOB",
			delivery_date: new Date().toISOString(),
			bought_qty: Number(firstQty?.total_qty) || 0,
			status: "NEW",
			stage: "DRAFTED",
			is_published: false,
			[allPOItemAssoc]: getItemRowsFromBody({
				fobPoItems: [
					{
						id: "po-1-item-1",
						style_id: firstStyle.id,
						color_id: firstColor?.color_id,
						total_qty: Number(firstQty?.total_qty) || 0,
						channel: firstQty?.channel || channelTypes.EBO.key,
						warehouse: firstQty?.warehouse || wearHouses.GGN.key,
					},
				],
			}),
		},
	];
};

const readStore = () => readJson(PO_STORE_KEY, seedPoRows());
const writeStore = (rows) => writeJson(PO_STORE_KEY, rows);

const wait = (value) => Promise.resolve(clone(value));

export const getSizeTypeMaster = async () => wait(readJson(SIZE_MASTER_STORE_KEY, createSizeTypeMaster()));

export const getSupplierList = async () => wait(readJson(SUPPLIER_STORE_KEY, createSuppliers()));

export const getStyles = async ({ channel, warehouse } = {}) => {
	const styles = getStyleCatalog().filter((row) => {
		const styleChannel = row?.channel || channelTypes.EBO.key;
		const styleWarehouse = row?.warehouse || wearHouses.GGN.key;
		const matchesChannel = !channel || styleChannel === channel;
		const matchesWarehouse = !warehouse || styleWarehouse === warehouse;
		return matchesChannel && matchesWarehouse;
	});
	return wait(styles.length ? styles : getStyleCatalog());
};

export const getAllPo = async () => wait(readStore());

export const deletePo = async (id) => {
	const current = readStore();
	const next = current.filter((row) => `${row.id}` !== `${id}`);
	writeStore(next);
	return wait(next);
};

export const createPo = async (body) => {
	const current = readStore();
	const id = body?.id || `po-${Date.now()}`;
	const items = getItemRowsFromBody(body);
	const nextRow = {
		...clone(body),
		id,
		order_no: body?.order_no && body.order_no !== "auto generate" ? body.order_no : `FOB-${current.length + 1001}`,
		date: body?.date || new Date().toISOString(),
		status: body?.status || "NEW",
		stage: body?.is_published ? "PUBLISHED" : "DRAFTED",
		is_published: !!body?.is_published,
		bought_qty: items.reduce((acc, row) => acc + (Number(row?.total_qty) || 0), 0),
		[allPOItemAssoc]: items,
	};
	const next = [nextRow, ...current.filter((row) => `${row.id}` !== `${id}`)];
	writeStore(next);
	return wait(nextRow);
};

export const updatePo = async (body) => {
	const current = readStore();
	const id = body?.id || body?.order_no;
	const items = getItemRowsFromBody(body);
	const next = current.map((row) => {
		if (`${row.id}` !== `${id}` && `${row.order_no}` !== `${id}`) return row;
		return {
			...row,
			...clone(body),
			id: row.id || id,
			stage: body?.is_published ? "PUBLISHED" : row.stage || "DRAFTED",
			is_published: body?.is_published ?? row.is_published,
			bought_qty: items.length ? items.reduce((acc, item) => acc + (Number(item?.total_qty) || 0), 0) : row.bought_qty,
			[allPOItemAssoc]: items.length ? items : row[allPOItemAssoc] || [],
		};
	});
	writeStore(next);
	return wait(next.find((row) => `${row.id}` === `${id}` || `${row.order_no}` === `${id}`) || body);
};
